interface DeactivateReviewFooterProps {
  onCancel: () => void;
  onContinue: () => void;
}

export default function DeactivateReviewFooter({
  onCancel,
  onContinue,
}: DeactivateReviewFooterProps) {
  return (
    <div className="px-[22px] py-3.5 border-t border-stone-200 dark:border-stone-800 bg-stone-50 dark:bg-[#1e2520] flex items-center gap-2.5 mt-2">
      <div className="flex-1 text-[11px] text-stone-500 dark:text-stone-400">Step 1 of 2</div>
      <button
        type="button"
        onClick={onCancel}
        className="h-8 px-3.5 rounded-lg text-[13px] font-semibold text-stone-600 dark:text-stone-400 hover:bg-stone-100 dark:hover:bg-[#242d28]"
      >
        Cancel
      </button>
      <button
        type="button"
        onClick={onContinue}
        className="inline-flex items-center gap-1.5 h-8 px-3.5 rounded-lg text-[13px] font-semibold text-clay-700 dark:text-clay-300 border border-clay-300 dark:border-clay-700 bg-white dark:bg-[#1a1f1c] hover:bg-clay-50 dark:hover:bg-clay-900/30"
      >
        Continue
      </button>
    </div>
  );
}
